import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const Logout = () => {
  const { setToken, setRole } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    try { localStorage.removeItem('auth_role'); } catch {}
    setRole(null as any);
    setToken(null);
    navigate("/login", { replace: true });
  };

  setTimeout(() => {
    handleLogout(); 
  }, 3 * 1000);

  return <>Logout Page</>;
};

export default Logout;